import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{"icon18/\u8868\u683C\u62BD\u53D6"}</title>
    <defs>
      <radialGradient
        cx="11.3172631%"
        cy="2.52121261%"
        fx="11.3172631%"
        fy="2.52121261%"
        r="124.298356%"
        id="Yij8unc8tuozrxT6dXQu5__radialGradient-1"
      >
        <stop stopColor="#8FFF98" offset="0%" />
        <stop stopColor="#38D4AE" offset="100%" />
      </radialGradient>
      <rect
        id="Yij8unc8tuozrxT6dXQu5__path-2"
        x={0}
        y={0}
        width={18}
        height={18}
        rx={2}
      />
      <filter
        x="-5.6%"
        y="-5.6%"
        width="111.1%"
        height="111.1%"
        filterUnits="objectBoundingBox"
        id="Yij8unc8tuozrxT6dXQu5__filter-3"
      >
        <feGaussianBlur
          stdDeviation={0.5}
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx={0}
          dy={1}
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2={-1}
          k3={1}
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.0530553431 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
      <linearGradient
        x1="109.459011%"
        y1="47.3726218%"
        x2="-21.7299389%"
        y2="45.2954861%"
        id="Yij8unc8tuozrxT6dXQu5__linearGradient-4"
      >
        <stop stopColor="#C4FFD8" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <path
        d="M13.75,2.25 C14.8545695,2.25 15.75,3.1454305 15.75,4.25 L15.75,13.75 C15.75,14.8545695 14.8545695,15.75 13.75,15.75 L4.25,15.75 C3.1454305,15.75 2.25,14.8545695 2.25,13.75 L2.25,4.25 C2.25,3.1454305 3.1454305,2.25 4.25,2.25 L13.75,2.25 Z M6.25,11.75 L3.75,11.75 L3.75,13.75 C3.75,13.9954599 3.92687516,14.1996084 4.16012437,14.2419443 L4.25,14.25 L6.25,14.25 L6.25,11.75 Z M10.25,11.75 L7.75,11.75 L7.75,14.25 L10.25,14.25 L10.25,11.75 Z M14.25,11.75 L11.75,11.75 L11.75,14.25 L13.75,14.25 C13.9954599,14.25 14.1996084,14.0731248 14.2419443,13.8398756 L14.25,13.75 L14.25,11.75 Z M6.25,7.75 L3.75,7.75 L3.75,10.25 L6.25,10.25 L6.25,7.75 Z M10.25,7.75 L7.75,7.75 L7.75,10.25 L10.25,10.25 L10.25,7.75 Z M14.25,7.75 L11.75,7.75 L11.75,10.25 L14.25,10.25 L14.25,7.75 Z M6.25,3.75 L4.25,3.75 C4.00454011,3.75 3.80039163,3.92687516 3.75805567,4.16012437 L3.75,4.25 L3.75,6.25 L6.25,6.25 L6.25,3.75 Z M10.25,3.75 L7.75,3.75 L7.75,6.25 L10.25,6.25 L10.25,3.75 Z M13.75,3.75 L11.75,3.75 L11.75,6.25 L14.25,6.25 L14.25,4.25 C14.25,4.00454011 14.0731248,3.80039163 13.8398756,3.75805567 L13.75,3.75 Z"
        id="Yij8unc8tuozrxT6dXQu5__path-5"
      />
      <filter
        x="-51.9%"
        y="-37.0%"
        width="203.7%"
        height="203.7%"
        filterUnits="objectBoundingBox"
        id="Yij8unc8tuozrxT6dXQu5__filter-6"
      >
        <feOffset dx={0} dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={2}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.0966327685   0 0 0 0 0.707915817   0 0 0 0 0.551221102  0 0 0 0.280951227 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g
      id="Yij8unc8tuozrxT6dXQu5__icon18/\u8868\u683C\u62BD\u53D6"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g id="Yij8unc8tuozrxT6dXQu5__\u77E9\u5F62">
        <use
          fill="url(#Yij8unc8tuozrxT6dXQu5__radialGradient-1)"
          fillRule="evenodd"
          xlinkHref="#Yij8unc8tuozrxT6dXQu5__path-2"
        />
        <use
          fill="black"
          fillOpacity={1}
          filter="url(#Yij8unc8tuozrxT6dXQu5__filter-3)"
          xlinkHref="#Yij8unc8tuozrxT6dXQu5__path-2"
        />
      </g>
      <g id="Yij8unc8tuozrxT6dXQu5__\u5F62\u72B6\u7ED3\u5408">
        <use
          fill="black"
          fillOpacity={1}
          filter="url(#Yij8unc8tuozrxT6dXQu5__filter-6)"
          xlinkHref="#Yij8unc8tuozrxT6dXQu5__path-5"
        />
        <use
          fill="url(#Yij8unc8tuozrxT6dXQu5__linearGradient-4)"
          fillRule="evenodd"
          xlinkHref="#Yij8unc8tuozrxT6dXQu5__path-5"
        />
      </g>
    </g>
  </svg>
);
const Memo = memo(Icon);
export default Memo;
